import React, { FC } from 'react'

import { ReactComponent as ClearIcon } from 'shared/img/close.svg'

import { Icon } from 'components/UIKit/Icon'

import { HiddenControl } from '../HiddenControl'

type Props = {
  canBeHidden?: boolean
  clearable?: boolean
  hasSuffix?: boolean
  isHidden?: boolean
  reveal: () => void
  hide: () => void
  onClear?: () => void
  value?: string
}

export const InputControls: FC<Props> = ({
  hasSuffix,
  canBeHidden,
  isHidden,
  hide,
  reveal,
  value,
  onClear,
  clearable,
}) => {
  if (canBeHidden) {
    return <HiddenControl isHidden={isHidden} reveal={reveal} hide={hide} hasSuffix={hasSuffix} />
  }

  if (onClear && value && clearable) {
    return <Icon type="close" onClick={onClear} />
  }

  return null
}
